import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'form-info-message',
  templateUrl: './form-info-message.component.html',
  styleUrls: ['./form-info-message.component.css']
})
export class FormInfoMessageComponent implements OnInit {
  config;
  group: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
